import { LocalConfig, NumericalConfig, PaymentConfig, FunctionalConfig } from "@/config";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendEvent } from "@/utils/Analytics";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, Toast } from "react-vant";
import { CopyToClipboard } from "react-copy-to-clipboard";
import style from "./style.less";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const DepositPageBlock = (props) => {
  const query = useQuery();
  const backTo = query.get("back_to");
  const { getPersist, setPersist, reloadUserInfo } = useContext(PersistContext);
  const { langText } = useContext(LanguageContext);
  const waitingTimer = React.useRef(null);
  const inputRef = React.useRef(null);
  const depositNowLaunched = React.useRef(false);
  const paymentsTopRef = React.useRef(null);

  //切换导航
  const history = useEnhancedHistory();

  const [payments, setPayments] = useState(PaymentConfig.payments);
  const [minDeposit, setMinDeposit] = useState(NumericalConfig.minDepositAmount / 100);
  const [maxDeposit, setMaxDeposit] = useState(NumericalConfig.maxDepositAmount / 100);
  const [backToUrl, setBackToUrl] = React.useState("");
  const [allDepositOptions, setAllDepositOptions] = useState(NumericalConfig.depositDefaultOptions);
  const [excludeDepositOptions, setExcludeDepositOptions] = useState({});
  const [depositOptions, setDepositOptions] = useState(NumericalConfig.depositDefaultOptions);
  const [depositOptionSeleted, setDepositOptionSeleted] = useState(1);
  const [firstRechargeBonus, setFirstRechargeBonus] = useState(false);
  const [firstRechargeLevels, setFirstRechargeLevels] = useState([]);
  //限时活动
  const [limitDiscounts, setLimitDiscounts] = useState(false);
  const [recallActOpen, setRecallActOpen] = useState(false);
  const [paymentIndex, setPaymentIndex] = useState(0);
  const [channelLimits, setChannelLimits] = useState({});
  const [rechargeLevelsLoaded, setRechargeLevelsLoaded] = useState(false);
  const [paymentsLoaded, setPaymentsLoaded] = useState(false);
  const [contactType, setContactType] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  useEffect(() => {
    let bgSettings = getPersist("bgSettings");
    if (!bgSettings) {
      return;
    }
    let merchant_usage = 0;
    let merchant_usable = [];
    if (bgSettings && bgSettings.settings && bgSettings.settings.merchant_usage) {
      merchant_usage = bgSettings.settings.merchant_usage;
    }
    if (bgSettings && bgSettings.settings && bgSettings.settings.client_config && bgSettings.settings.client_config.contactType) {
      setContactType(bgSettings.settings.client_config.contactType);
    }
    if (bgSettings && bgSettings.settings && bgSettings.settings.client_config && bgSettings.settings.client_config.contactNumber) {
      setContactNumber(bgSettings.settings.client_config.contactNumber);
    }
    if (
      bgSettings &&
      bgSettings.settings &&
      bgSettings.settings.client_config &&
      bgSettings.settings.client_config.rechargePayments
    ) {
      for (let i = 0; i < bgSettings.settings.client_config.rechargePayments.length; i++) {
        if (bgSettings.settings.client_config.rechargePayments[i].usable) {
          merchant_usable.push(bgSettings.settings.client_config.rechargePayments[i].id);
        }
      }
    }
    if (merchant_usable.length <= 0) {
      merchant_usable.push(merchant_usage);
    }
    let tmpPayments = [];
    let defaultRechargeIndex = 0;
    let userPhone = getPersist("user_info") ? getPersist("user_info").rolename : "";
    if (!userPhone || userPhone == "") {
      userPhone = getPersist("last_phone");
    }
    for (let i = 0; i < PaymentConfig.payments.length; i++) {
      if (merchant_usable.indexOf(PaymentConfig.payments[i].merchantId) == -1) {
        console.log("merchant_usable", PaymentConfig.payments[i].merchantId);
        continue;
      }
      tmpPayments.push(PaymentConfig.payments[i]);
      //优先使用后台配置的默认支付方式
      if (userPhone && PaymentConfig.payments[i].checkPrecedence(userPhone)) {
        defaultRechargeIndex = tmpPayments.length - 1;
      }
      if (
        bgSettings.settings.client_config.defaultRecharge &&
        bgSettings.settings.client_config.defaultRecharge == PaymentConfig.payments[i].merchantId &&
        tmpPayments[defaultRechargeIndex].merchantId != bgSettings.settings.client_config.defaultRecharge
      ) {
        defaultRechargeIndex = tmpPayments.length - 1;
      }
    }
    console.log("defaultRechargeIndex", defaultRechargeIndex);
    setPayments(tmpPayments);
    if (tmpPayments.minDepositAmount) {
      setMinDeposit(tmpPayments.minDepositAmount / 100);
    }
    if (tmpPayments.maxDepositAmount) {
      setMaxDeposit(tmpPayments.maxDepositAmount / 100);
    }
    setPaymentIndex(defaultRechargeIndex);
    setPaymentsLoaded(true);
  }, [getPersist("bgSettings")]);

  useEffect(() => {
    if (!paymentsLoaded || !rechargeLevelsLoaded) {
      return;
    }
    onPaymentIndexChange(paymentIndex);
    if (query.get("deposit_now")) {
      if (depositNowLaunched.current) {
        return;
      }
      let depositAmount = parseInt(query.get("deposit_now"), 10);
      //检查defaultRechargeIndex对应的支付方式里面depositAmount是否可用
      let payment = payments[paymentIndex];
      if (!payment) {
        console.error("payment not available", paymentIndex);
        return;
      }
      console.log(payment);
      console.log(
        "res.merchant_exclude_recharge_levels[payment.merchantId]",
        excludeDepositOptions[payment.merchantId]
      );
      if (
        excludeDepositOptions[payment.merchantId] &&
        excludeDepositOptions[payment.merchantId].includes(depositAmount * 100)
      ) {
        console.error("depositAmount not available", depositAmount);
        return;
      }
      let index = null
      for (let i = 0; i < depositOptions.length; i++) {
        if (depositOptions[i].price == depositAmount * 100) {
          index = i;
        }
      }
      setDepositPrice(depositAmount);
      setDepositOptionSeleted(index);
      //doRecharge(depositAmount, paymentIndex);
      console.error("depositOptions:", depositOptions)
      depositNowLaunched.current = true;
    }
  }, [paymentsLoaded, rechargeLevelsLoaded]);

  const onPaymentIndexChange = useCallback(

    (index) => {
      if (typeof index == "undefined") {
        index = paymentIndex;
      } else {
        setPaymentIndex(index);
      }
      let payment = payments[index];
      let willOptions = [...allDepositOptions];
      console.log("onPaymentIndexChange", index, willOptions, payment.merchantId);
      if (payment && excludeDepositOptions[payment.merchantId]) {
        willOptions = willOptions.filter((option) => !excludeDepositOptions[payment.merchantId].includes(option.price));
      }
      setDepositOptions(willOptions);
      changeSelectedOption(willOptions[0], 0);
      if (paymentsTopRef.current) {
        let offset = 0;
        //获取1rem的宽度
        let rem = document.documentElement.style.fontSize.replace("px", "");
        //获取当前选中的支付方式的索引
        let itemPx = 5.5 * rem;
        offset = index * itemPx;
        //获取当前paymentsTopRef的宽度
        let divWidth = paymentsTopRef.current.offsetWidth;
        //如果当前选中的支付方式的索引大于paymentsTopRef的宽度，就让paymentsTopRef滚动到当前选中的支付方式的位置
        let divLeft = paymentsTopRef.current.scrollLeft;
        let divRight = divLeft + divWidth;
        if (offset + itemPx < divLeft || offset > divRight) {
          paymentsTopRef.current.scrollLeft = offset - 10;
        }
      }
    },
    [allDepositOptions, excludeDepositOptions, payments]
  );

  //输入框
  let [depositGot, setDepositGot] = useState(NumericalConfig.defaultDepositGot);
  let [depositPrice, setDepositPrice] = useState(NumericalConfig.defaultDepositPrice);

  const [diaLogVisible, setDiaLogVisible] = useState(false);
  const [waitingOrderId, setWaitingOrderId] = useState("");

  useEffect(() => {
    getRechargeLevels();
    if (query.get("wait_order_id")) {
      setWaitingOrderId(query.get("wait_order_id"));
      let nowBgwaittingOrders = getPersist("bg_waitting_recharge_orders");
      if (nowBgwaittingOrders) {
        let wait_order_idInnowBgwaittingOrders = false;
        for (let i = 0; i < nowBgwaittingOrders.length; i++) {
          if (nowBgwaittingOrders[i].order_id == query.get("wait_order_id")) {
            wait_order_idInnowBgwaittingOrders = true;
            break;
          }
        }
        if (!wait_order_idInnowBgwaittingOrders) {
          setPersist("bg_waitting_recharge_orders", [...nowBgwaittingOrders, { order_id: query.get("wait_order_id"), created_at: Date.now() }]);
        }
      }
      setDiaLogVisible(true);
    }
    return () => {
      if (waitingTimer.current) {
        clearInterval(waitingTimer.current);
      }
    };
  }, []);
  React.useEffect(() => {
    //有backTo的时候，记住要跳转回去的页面
    if (backTo) {
      setBackToUrl(backTo);
    }
    //没有backTo的时候不管，防止注册登录互切的时候，backTo丢失
    console.log("backTo", backTo);
  }, [backTo]);

  useEffect(() => {
    console.log(diaLogVisible, waitingOrderId);
    if (diaLogVisible && waitingOrderId) {
      if (waitingTimer.current) {
        clearInterval(waitingTimer.current);
      }
      waitingTimer.current = setInterval(() => {
        SendCMD("checkRechargeOrder", {
          token: getPersist("user_info").token,
          order_id: waitingOrderId,
        }).then((res) => {
          if (res.status) {
            if (res.data == "SUCCESS" || res.data == "MANUAL") {
              completedDialog(true);
            } else if (res.data == "FAILD") {
              completedDialog(false);
            }
          }
        });
      }, 2000);
    } else if (waitingTimer.current) {
      clearInterval(waitingTimer.current);
    }
  }, [diaLogVisible, waitingOrderId]);

  const getRechargeLevels = () => {
    console.log("getRechargeLevels", props);
    let params = {};
    if (getPersist("user_info")) {
      params = {
        token: getPersist("user_info").token,
      };
    }
    if (props.useCouponId) {
      params.coupon_id = props.useCouponId;
    }
    SendCMD("getRechargeLevels", params).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else {
        let option = [];
        let haveMoreOptionIndex = -1;
        res.levels.map((value, index) => {
          option.push(value);
          if (value.more) {
            haveMoreOptionIndex = index;
          }
        });
        if (haveMoreOptionIndex > -1) {
          changeSelectedOption(option[haveMoreOptionIndex], haveMoreOptionIndex);
        }
        setAllDepositOptions(option);
        setExcludeDepositOptions(res.merchant_exclude_recharge_levels);
        if (res.limits) {
          setChannelLimits(res.limits);
        }
        console.log("getRechargeLevels depositPage:", res)
        if (res.recall_act_open && res.recall_act_now && res.recall_act_end_time && res.recall_act_now < res.recall_act_end_time) {
          setRecallActOpen(res.recall_act_open);
          //字段表示是否完成了优惠活动
          setLimitDiscounts(res.recall_act_open)
        }
        setFirstRechargeBonus(res.first_recharge_bonus);
        let first_recharge_levels = []
        for (const key in res.first_recharge_levels) {
          first_recharge_levels.push(Number(key))
        }
        setFirstRechargeLevels(first_recharge_levels);
        setRechargeLevelsLoaded(true);
      }
    });
  };

  const doRecharge = (amount, usePaymentIndex) => {
    SendEvent("deposit_click", { price: amount * 100, signed_in: !!getPersist("user_info") });
    if (!getPersist("user_info")) {
      setPersist(
        "login_back_url",
        `${location.pathname + location.search + (location.search ? "&" : "?")}show_pay_popup=${props.fromPopup ? "1" : "0"
        }`
      );
      history.push(
        ChannelRemind(
          `/login?${getPersist("last_phone") ? "" : "reg=1&"}back_to=${encodeURIComponent(
            location.pathname +
            location.search +
            (location.search ? "&" : "?") +
            (props.fromPopup ? "show_pay_popup=1" : "")
          )}`
        )
      );
      return;
    }
    let requestDeposit = depositPrice;
    if (amount) {
      requestDeposit = amount;
    }
    if (!requestDeposit || requestDeposit < minDeposit) {
      return;
    }

    let payment = payments[paymentIndex];
    if (usePaymentIndex && payments[usePaymentIndex]) {
      payment = payments[usePaymentIndex];
    }
    //兼容没有支付方式的情况
    if (!payment) {
      payment = {
        merchantId: 0,
        type: "",
      };
    }

    if (requestDeposit > 0) {
      if (
        channelLimits[payment.merchantId] &&
        channelLimits[payment.merchantId].min &&
        requestDeposit < channelLimits[payment.merchantId].min / 100
      ) {
        Toast.info({
          overlay: true,
          className: style.limit_toast,
          message: (
            <div>
              {langText("deposit_tips_12")}{" "}
              <span style={{ color: "red" }}>
                {channelLimits[payment.merchantId].min / 100}
                {LocalConfig.currencyCode}
              </span>
              .<br /> {langText("deposit_tips_14")}
            </div>
          ),
          duration: 5000,
        });
        return;
      }
      if (
        channelLimits[payment.merchantId] &&
        channelLimits[payment.merchantId].max &&
        requestDeposit > channelLimits[payment.merchantId].max / 100
      ) {
        Toast.info({
          overlay: true,
          className: style.limit_toast,
          message: (
            <div>
              {langText("deposit_tips_13")}{" "}
              <span style={{ color: "red" }}>
                {channelLimits[payment.merchantId].max / 100}
                {LocalConfig.currencyCode}
              </span>
              .<br /> {langText("deposit_tips_15")}
            </div>
          ),
          duration: 5000,
        });
        return;
      }
      setDiaLogVisible(true);
      // SendCMD("simulateRecharge", {
      SendCMD("recharge", {
        token: getPersist("user_info").token,
        price: requestDeposit * 100,
        merchant_id: payment.merchantId,
        coupon_id: props.useCouponId ? props.useCouponId : 0,
        type: payment.type,
      }).then((res) => {
        if (!res.status) {
          console.log(res);
          if (res.errdcode == "recharge_13") {
            SendEvent("deposit_request_failed", { price: requestDeposit * 100, reason: res.errdesc });
            setDiaLogVisible(false);
            Toast.success({ message: "Too many requests!\nPlease try again later.", duration: 4000 });
            return;
          }
          SendEvent("deposit_request_failed", { price: requestDeposit * 100, reason: res.errdesc });
          setDiaLogVisible(false);
          Toast.success({ message: "Error", duration: 2000 });
        } else {
          console.log(res.data.order_id);
          SendEvent("deposit_request_success", { price: requestDeposit * 100 });
          let nowBgwaittingOrders = getPersist("bg_waitting_recharge_orders");
          if (!nowBgwaittingOrders || !Array.isArray(nowBgwaittingOrders)) {
            nowBgwaittingOrders = [];
          }
          setPersist("bg_waitting_recharge_orders", [...nowBgwaittingOrders, { order_id: res.data.order_id, created_at: Date.now() }]);
          if (res.data.checkout_url) {
            window.location.href = res.data.checkout_url;
          } else {
            setWaitingOrderId(res.data.order_id);
          }
        }
      });
    }
  };

  const completedDialog = (success) => {
    setDiaLogVisible(false);
    setWaitingOrderId("");
    reloadUserInfo();
    if (props.completedDialog && typeof props.completedDialog == "function") {
      return props.completedDialog(success);
    }
    if (typeof success != "undefined") {
      if (success) {
        SendEvent("deposit_confirm_success");
        Toast.success({
          message: `Success`,
          duration: 2000,
          onClose: () => {
            history.replace(ChannelRemind("/home"));
            Toast.clear();
          },
        });
      } else {
        SendEvent("deposit_confirm_failed");
        Toast.fail({
          message: `Error`,
          duration: 2000,
        });
      }
    } else {
      SendEvent("deposit_confirm_clicked");
      history.replace(ChannelRemind("/home"));
      Toast.clear();
    }
  };

  const changeSelectedOption = (option, index) => {
    setDepositGot(option.get / 100);
    setDepositPrice(option.price / 100);
    setDepositOptionSeleted(index);
  };
  const onOptionSelected = (index) => {
    changeSelectedOption(depositOptions[index], index);
  };

  return (
    <>
      <div style={{
        // padding: "0 .95rem",
        backgroundColor: "black",
        position: "fixed",
        borderBottom: "0.13rem solid rgb(46, 80, 66)",
        zIndex: 1
      }}>
        <div style={{ marginTop: "1rem", marginLeft: "0.95rem", color: "#fff", fontWeight: "bolder", fontSize: "1rem", fontFamily: "home_new" }}>
          {langText("deposit_title_4")}
        </div>
        <div class={style.bottom} style="border-top-left-radius: 0px;">
          <img
            src="../assets/images/home/icon_tanhao.png"
            alt=""
            style={{ width: "1rem", height: "1rem", marginLeft: "0.4rem", marginTop: "-0.4rem" }}
          />
          <div>
            <div class={style.depositeText}>
              { }
              {langText("deposit_tips_2")}
            </div>
          </div>
        </div>
        <div style={{ color: "rgb(157, 157, 157)", fontWeight: "bolder", fontSize: "0.75rem", marginTop: "0rem", marginLeft: "2.1rem", marginRight: "0.5rem", marginBottom: "1rem" }}>
          <span style={{ color: "rgb(68, 141, 64)" }}>
            {contactType}:&nbsp;
          </span>
          <CopyToClipboard
            text={contactNumber}
            onCopy={() => {
              Toast.success({
                message: "Copy Successfully",
              });
            }}
          >
            <span style={{ color: "rgb(153, 229, 149)", textDecoration: "underline" }}>
              @{contactNumber}
              <img style={{ width: "1rem", height: "1rem", marginLeft: "0.4rem" }} src={require("@/assets/icons/copy_green.png").default} />
            </span>
          </CopyToClipboard>
        </div>
        {payments.length > 0 && (
          <div class={style.deposit_choose}>
            <div class={style.deposit_top} style={FunctionalConfig.newPromotion ? { height: "3.5rem" } : {}} ref={paymentsTopRef}>
              {payments.map((payment, index) => {
                return (
                  <div
                    key={`${index}`}
                    class={index == paymentIndex ? style.fatherbox_active : style.fatherbox}
                    onClick={() => onPaymentIndexChange(index)}
                  >
                    <div class={index == paymentIndex ? style.son_active : style.son} style={FunctionalConfig.newPromotion
                      ? { height: "3rem", boxSizing: "border-box", borderRadius: "0.5rem", border: "0.13rem solid rgb(81, 142, 117)" }
                      : { boxSizing: "border-box", borderRadius: "0.5rem", border: "0.13rem solid rgb(81, 142, 117)" }}
                    >
                      <div
                        style={
                          index == paymentIndex ? {
                            width: "100%",
                            textAlign: "center",
                            marginTop: "0.4rem",
                            marginBottom: "0.3rem",
                            color: "#fff",
                            fontSize: "0.8rem",
                            fontWeight: "bolder",
                          } : {
                            width: "100%",
                            textAlign: "center",
                            marginTop: "0.4rem",
                            marginBottom: "0.3rem",
                            color: "rgb(142, 184, 168)",
                            fontSize: "0.8rem",
                            fontWeight: "bolder",
                          }}
                      >
                        <span>{langText("deposit_btn_3")} {" " + (payment.abridgeText ? payment.abridgeText : index + 1)}</span>
                        {/* <span style={payment.text == "mmpay" && {fontSize:"0.9rem"}}>{payment.text}</span> */}
                      </div>
                      {payment.img && payment.img.length > 0 && (
                        <div
                          style={{
                            height: "1.3rem",
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignContent: "center",
                            marginBottom: "0.5rem",
                            marginTop: "-0.1rem",
                          }}
                        >
                          {payment.img.map((imageSrc, i) => (
                            <img key={`${i}`} style={{ margin: "0 0.1rem", maxWidth: "4rem", maxHeight: "1rem", width: "auto", height: "auto" }} src={imageSrc} alt="" />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <div className={style.drop_down_anim} >
        <img style={{ width: "auto", height: "1.1rem" }} src={require("@/assets/images/home/drop_down.png").default} alt="" />
      </div>
      <div class={style.deposit_title} style={{ marginTop: "10.5rem" }}>{langText("deposit_title_1")}</div>
      <div class={style.depevebox_outer}>
        <div class={style.depevebox}>
          {depositOptions.map((option, i) => {
            return (
              <div
                key={i}
                class={style.depeveboxson_outer}
              >
                <div
                  class={style.depeveboxson + (depositOptionSeleted === i ? ` ${style.depeveboxson_active}` : "")}
                  onClick={() => {
                    SendEvent("deposit_option_click", {
                      index: i,
                      price: option.price,
                      signed_in: !!getPersist("user_info"),
                    });
                    onOptionSelected(i);
                  }}
                >
                  {option.hot ? <div class={style.hotdiv}>Hot</div> : null}
                  {!(option.price == NumericalConfig.limitDiscounts && limitDiscounts) && option.more ? <div class={style.morediv}>+{option.more}%</div> : null}
                  {(!(option.price == NumericalConfig.limitDiscounts && limitDiscounts)) && (option.price == NumericalConfig.depositActivityAmount && recallActOpen) ? <div class={style.morediv}>+{NumericalConfig.depositActivityMore}%</div> : null}
                  {!option.more && option.price == NumericalConfig.firstRechargeAmount && firstRechargeLevels.indexOf(NumericalConfig.firstRechargeAmount) < 0 ? (
                    <div class={style.hotdiv}>1st-time+30%</div>
                  ) : null}
                  {!option.more && option.price == NumericalConfig.firstRechargeAmount2 && firstRechargeLevels.indexOf(NumericalConfig.firstRechargeAmount2) < 0 ? (
                    <div class={style.hotdiv}>1st-time+20%</div>
                  ) : null}
                  {option.price == NumericalConfig.limitDiscounts && limitDiscounts ? (
                    < div class={style.hotdiv}>1st-time+750</div>
                  ) : null}
                  <div class={style.depone} style={depositOptionSeleted === i ? "color: #004b20;" : null}>
                    {LocalConfig.currencyCode}
                  </div>
                  <div class={style.depone_get} style={depositOptionSeleted === i ? "color:  #004b20;" : null}>
                    {(option.get / 100).toFixed(2)}
                  </div>
                  <div class={style.deptwo} style={depositOptionSeleted === i ? "color:  #004b20;" : null}>
                    {langText("deposit_btn_2")} {(option.price / 100).toFixed(2)}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div >
      <div class={style.deposit_content}>
        <div class={style.deposit_inbox}>
          <div class={style.deposit_calculator_header}>
            <div class={style.calculator_left}>
              <div>{langText("deposit_tips_5")}</div>
              <div>&nbsp;</div>
              <div>{langText("deposit_tips_6")}</div>
            </div>
            <div class={style.calculator_middle}> &nbsp; </div>
            <div class={style.calculator_right}>{langText("deposit_tips_7")}</div>
          </div>
          <div class={style.deposit_calculator_equation}>
            <div
              class={style.calculator_left}
              style={{
                borderColor: "rgb(81, 142, 117)",
                borderWidth: ".15rem",
                borderStyle: "solid",
                borderRadius: 99,
                backgroundColor: "rgba(81, 142, 117,0.2)",
              }}
            >
              <div>{depositPrice.toFixed(2)}</div>
              <div>+</div>
              <div style={{ color: "#e4ff4d" }}>{(depositGot - depositPrice).toFixed(2)}</div>
            </div>
            <div class={style.calculator_middle}>=</div>
            <div
              class={style.calculator_right}
              style={{
                borderColor: "rgb(81, 142, 117)",
                borderWidth: ".15rem",
                borderStyle: "solid",
                borderRadius: 99,
                backgroundColor: "rgba(81, 142, 117,0.2)",
                color: "#e4ff4d",
              }}
            >
              {depositGot.toFixed(2)}
            </div>
          </div>
        </div>

        <div class={style.btncommontwo}>
          <div class={style.paybtnbox}>
            <button
              class={`${style.paybtn} ${style.paybtn1}${depositGot < minDeposit ? ` ${style.paybtn_disabled}` : ""}`}
              onClick={() => doRecharge()}
            >
              {langText("deposit_btn_1")}{" "}
              <span style="margin-left: .35rem;">
                {LocalConfig.currencyCode} {depositGot && depositGot >= minDeposit ? depositPrice.toFixed(2) : null}
              </span>
            </button>
          </div>
        </div>
        <div style={{ color: "rgb(157, 157, 157)", fontWeight: "bolder", fontSize: "1rem", marginTop: "0.5rem", marginLeft: "0.5rem", marginRight: "0.5rem", textAlign: "center" }}>
          <span>
            {langText("deposit_tips_16")}
          </span>
        </div>

        {FunctionalConfig.pakistanLeader && (
          <div class={style.deposit_describe} style={{ marginTop: "1rem", marginBottom: "-0.5rem" }}>
            <h4 style={{ color: "rgb(68, 141, 64)" }}>{langText("deposit_title_3")}</h4>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(144, 206, 170)" }}>1.</span>
              <span style={{ color: "rgb(144, 206, 170)" }}> {langText("deposit_desc_6")} </span>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(144, 206, 170)" }}>2.</span>
              <span style={{ color: "rgb(144, 206, 170)" }}> {langText("deposit_desc_7")} </span>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(144, 206, 170)" }}>3.</span>
              <span style={{ color: "rgb(144, 206, 170)" }}> {langText("deposit_desc_8")} </span>
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <span style={{ color: "rgb(144, 206, 170)" }}>4.</span>
              <span style={{ color: "rgb(144, 206, 170)" }}> {langText("deposit_desc_9")} </span>
            </div>
          </div>
        )}

        <div class={style.deposit_describe}>
          <h5>{langText("deposit_title_2")}</h5>
          <p> {langText("deposit_desc_1")} </p>
          <p>
            {" "}
            {langText("deposit_desc_2", { param1: LocalConfig.currencyCode, param2: (NumericalConfig.minDepositAmount / 100).toFixed(2) })}
            {" "}
          </p>
          <p> {langText("deposit_desc_3")} </p>
          <p> {langText("deposit_desc_4")} </p>
          <p> {langText("deposit_desc_5")} </p>
        </div>

        <div class={style.deposit_phone}>
          <img src={LocationInfo().flag} alt="" />
          <span class={style.deposit_pc}>+{LocationInfo().phoneStartsWith}</span>
          <span>{getPersist("user_info") ? getPersist("user_info").rolename : null}</span>
        </div>
        <p class={style.depositedes}>
          {langText("deposit_tips_3")}
        </p>

        <Dialog
          visible={diaLogVisible}
          title={
            <div class={style.deposit_puptop}>
              <p class={style.deposit_load}>{langText("deposit_tips_8")}</p>
            </div>
          }
          className={style.depositDialog}
          showCancelButton={false}
          showConfirmButton={false}
        >
          <div class={style.dialog_content}>
            <div class={style.infinite_progress}>
              <div class={style.infinite_progress_img} />
            </div>
            <div class={style.pup_tips}>
              <p>{langText("deposit_tips_9")}</p>
            </div>
            <div class={style.pup_make}>
              <p class={style.pup_p1}>{langText("deposit_tips_10")}</p>
            </div>
            <div class={style.pup_btn}>
              <button class="" onClick={() => completedDialog()}>
                {langText("withdraw_btn_1")}
              </button>
            </div>
            <div class={style.pup_foot}>
              <p>
                {langText("deposit_tips_11")}
              </p>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default DepositPageBlock;
